import React, { useState } from 'react'
import { Route, Navigate } from 'react-router-dom'
import AuthService from '../../../services/auth-service/AuthService'
import UserService from '../../../services/user-service/UserService'
import PropTypes from 'prop-types'

const PrivilegieRoute = ({ component: Component, ...rest }) => {
    const [slug] = useState(rest.computedMatch.params.slug)

    async function checkAction() {
        try {
            const response = await UserService.findActionsBySlug(slug)

            const actions = response.data
            const hasAction = actions.filter(action => action.toLowerCase() === 'manage_miniapp_devs').length > 0
            return hasAction
        } catch (e) {
            console.error('ERROR: ', e)
            return false
        }
    }

    async function checkPrivelegie() {
        try {
            const isAuth = AuthService.isAuthenticated()
            if (!isAuth) {
                return false
            }

            const isFisrtLogin = AuthService.isFirstLogin()
            if (isAuth && isFisrtLogin) {
                return false
            }

            const decodedToken = AuthService.getDecodedToken()
            const scopes = decodedToken.scopes
            const hasScope = scopes.filter(scope => scope.toLowerCase() === 'manage_miniapp_devs').length > 0

            if (!hasScope) {
                const enablePrivelegie = await checkAction()
                return enablePrivelegie
            }

            return hasScope
        } catch (e) {
            console.error('ERROR: ', e)
            return false
        }
    }

    return (
        <Route
            {...rest}
            render={props =>
                checkPrivelegie() ? (
                    <Component {...props} />
                ) : (
                    <Route path="*" element={<Navigate to={`/developer/${slug}/invites`} />} />
                )
            }
        />
    )
}

PrivilegieRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.any,
}

export default PrivilegieRoute
